module.exports = __webpack_public_path__ + "static/media/Check_thick_gray.6401a581.svg";